module.exports = __webpack_public_path__ + "img/speaker.af1fc4a4.svg";